const env = process.env.REACT_APP_ENV || 'production';

const config = {
  env,
  name: 'jsonpad',
  url: env === 'local' ? 'http://localhost:3000' : 'https://jsonpad.io',

  // API
  api: {
    url: env === 'local' ? 'http://localhost:8000' : 'https://api.jsonpad.io',
  },

  // API status, from the public UptimeRobot status page. The JSON endpoint is
  // the one the status page itself uses; it isn't documented, so anything
  // unexpected in the response is treated as an unknown status
  status: {
    pageUrl: 'https://stats.uptimerobot.com/6qT7rAbk4j',
    apiUrl: 'https://stats.uptimerobot.com/api/getMonitorList/6qT7rAbk4j',
    refreshInterval: 300,
  },

  // Debug
  debug: {
    showTestPage: false,
    bypassRateLimit: false,
    bypassSubscription: null,
    bypassAuth: false,
    overrideUserId: null,
  },

  // Firebase SDK credentials
  firebase:
    env === 'local'
      ? {
          apiKey: 'AIzaSyCEKYor96JM2Aa2Cx77AF5rNODffU3dBGo',
          authDomain: 'jsonpad-dev.firebaseapp.com',
          projectId: 'jsonpad-dev',
          storageBucket: 'jsonpad-dev.appspot.com',
          messagingSenderId: '289503168395',
          appId: '1:289503168395:web:cdfe79ff8ab6ded911118e',
        }
      : {
          apiKey: 'AIzaSyDiEnUpZIJToRhoiSTpRSE47Zt9x7ho9Kk',
          authDomain: 'jsonpad-io.firebaseapp.com',
          projectId: 'jsonpad-io',
          storageBucket: 'jsonpad-io.appspot.com',
          messagingSenderId: '331940859212',
          appId: '1:331940859212:web:a1001ec48af83f61fbd3e9',
          measurementId: 'G-RD61NW5B08',
        },

  // Dashboard & UI
  dashboardDays: 7,
  bulletinRefreshInterval: 60,
  cachedResourcesRefreshInterval: 60,
  pageDateFormat: 'D MMM YYYY HH:mm:ss',
  pageShortDateFormat: 'D MMM YYYY',
  datePickerDateFormat: 'D MMM YYYY',
  chartDateFormatDays: 'D MMM',
  chartDateFormatMinutes: 'HH:mm',
  eventsPageSize: 20,
  eventsPageHeaderDateFormat: 'D MMM YYYY',
  homePageNewsItemsLimit: 3,
  showHomePageBetaBanner: false,
  generativeAPIEnabled: false,
  generativeAPISubscriptionPlans: ['free', 'indie', 'pro', 'scale'],

  // Config from server (should match those in server/src/constants.ts)
  statsDefaultDays: 7,
  statsMaxDays: 90,

  // Identicons
  identicons: {
    size: 42,
    fontSize: 0.5,
    initialsOffset: {
      x: 0,
      y: 1,
    },
    baseSeed: 'jsonpad',
    initialsColours: ['#31363F'],
  },

  // Cloudflare Web Analytics
  cloudflare: {
    webAnalyticsToken: '8de6fb036f7d4ad0b3d55f8872c5acb6',
  },
};

export default config;
